import React from "react";
import DialogBoxWithFooter from "../../../util/DialogBoxWithFooter";
import DialogBoxWithConfirmation from "../../../util/DialogBoxWithConfirmation";
import "../../../style/global.css";
import { useTranslation } from "react-i18next";

const ButtonsFeatures = ({
  sendDataToServ,
  originMarker,
  destinationMarker,
  userPack,
  handleExport,
  setShowInputGPX,
  setShowInputKML,
  showInputGPX,
  showInputKML,
  handleKmlUpload,
  handleProjectUpload,
  handleGpxUpload,
  setShowInputGPXKml,
  showInputGPXKml,
  setVisibleComponent,
}) => {
  const { t } = useTranslation();

  // Fonctions utilitaires pour afficher l'icône premium
  const renderPremiumIcon = () =>
    userPack === "Standard" && (
      <span className="text-warning">
        <i className="bi bi-stars"></i>
      </span>
    );

  const handlePremiumDialog = (feature) => {
    DialogBoxWithFooter({
      title: t("premiumFeatures"),
      text: t(feature),
      icon: "warning",
      confirmButtonText: "OK",
      footer: t("toBePremium"),
      footerOnClick: () => setVisibleComponent("Subscriptions"),
    });
  };

  async function handleSaveClick() {
    if (!originMarker?.lat || !destinationMarker?.lat) {
      const confirmSave = await DialogBoxWithConfirmation({
        title: t("titleDialogBoxMissingPoints"),
        text: t("messageDialogBoxMissingPoints"),
        icon: "warning",
        cancelButtonText: t("no"),
        confirmButtonText: t("yes"),
      });

      if (!confirmSave) {
        return;
      }
    }
    sendDataToServ();
  }
  return (
    <div className="">
      <div className="d-flex justify-content-around mt-2">
        <button
          className="buttonsFeatures"
          onClick={handleSaveClick}
          aria-label="Sauvegarder"
        >
          <i className="bi bi-save"></i>
          {t("save")}
        </button>

        <div className="dropdown">
          <button
            className="buttonsFeatures"
            type="button"
            data-bs-toggle="dropdown"
          >
            <i className="bi bi-box-arrow-down"></i> {t("export")}
            {renderPremiumIcon()}
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleExport(false)}
                title="Télécharger en local"
              >
                {t("locally")}
                {renderPremiumIcon()}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="d-flex justify-content-around mt-2">
        <div className="dropdown">
          <button
            className="buttonsFeatures"
            type="button"
            data-bs-toggle="dropdown"
            onClick={() =>
              userPack === "Standard" &&
              handlePremiumDialog("premiumImportProject")
            }
          >
            <i className="bi bi-arrow-down-circle"></i> {t("import")}
            <span className="text-warning ms-1" hidden={userPack === "Premium"}>
              <i className="bi bi-stars"></i>
            </span>
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  setShowInputGPX(!showInputGPX);
                  setShowInputKML(false);
                  setShowInputGPXKml(false);
                }}
                title="Importer parcours"
              >
                {t("parcours")}
              </button>
              <button
                className="dropdown-item"
                onClick={() => {
                  setShowInputKML(!showInputKML);
                  setShowInputGPX(false);
                }}
                title="Importer KML"
              >
                {t("kml")}
              </button>
              <button
                className="dropdown-item"
                onClick={() => {
                  // L'import GPX est une opération locale (parsing + dessin) :
                  // plus de cooldown — l'ancienne contrepartie serveur
                  // (conversion GPX→KML poussée) a disparu avec le stockage
                  // GitHub, et la sauvegarde possède ses propres garde-fous
                  // (verrou, bilan d'échecs). Un enchaînement d'imports est
                  // légitime (remplacement puis complémentaire).
                  setShowInputGPXKml(!showInputGPXKml);
                  setShowInputKML(false);
                  setShowInputGPX(false);
                }}
                title="Importer GPX"
              >
                {t("gpx")}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <br />
      {showInputKML && !showInputGPX && (
        <div className="justify-content-around">
          <input
            className="form-control"
            type="file"
            accept=".kml"
            onChange={handleKmlUpload}
          />
        </div>
      )}

      {showInputGPX && !showInputKML && (
        <div className="justify-content-around">
          <input
            className="form-control"
            type="file"
            accept=".gpx"
            onChange={handleProjectUpload}
          />
        </div>
      )}

      {showInputGPXKml && (
        <div className="justify-content-around">
          <input
            className="form-control"
            type="file"
            accept=".gpx"
            onChange={handleGpxUpload}
          />
        </div>
      )}
    </div>
  );
};

export default ButtonsFeatures;
